import { AtlasThemeProvider } from '@diligentcorp/atlas-theme-mui';
import { lensThemeOptions } from '@diligentcorp/atlas-theme-mui/lib/themes/lens/index.js';
import React from 'react';

interface AtlasMuiThemeProviderProps {
  children: React.ReactNode;
}

export const AtlasMuiThemeProvider: React.FC<AtlasMuiThemeProviderProps> = ({
  children,
}) => (
  <AtlasThemeProvider themeOptions={lensThemeOptions}>
    {children}
  </AtlasThemeProvider>
);
